export default __webpack_public_path__ + "static/media/skippedmeal@2x.1fbc4230.jpg";